import { useNavigate } from '@exam-management/router';
import { Button, type ButtonProps, AddRoundedIcon } from '@shared/components';

export default function QuestionReviewTaskCreationButton(props: Readonly<ButtonProps>) {
  const navigate = useNavigate();

  const handleCreateTask = () => {
    navigate('/task-management/question-review/create');
  };

  return (
    <Button startIcon={<AddRoundedIcon />} color='primary' onClick={handleCreateTask} {...props}>
      Create Task
    </Button>
  );
}
